export default __webpack_public_path__ + "static/media/logo.091e35ee.png";